import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import LandingPage from "@/pages/LandingPage";
import PricingPage from "@/pages/PricingPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import FeaturesPanel from "@/pages/admin/FeaturesPanel";
import FeatureEditorPage from "@/pages/admin/FeatureEditorPage";
import CategoriesPanel from "@/pages/admin/CategoriesPanel";
import IndustriesPanel from "@/pages/admin/IndustriesPanel";
import TagsPanel from "@/pages/admin/TagsPanel";
import SiteSettingsPanel from "@/pages/admin/SiteSettingsPanel";
import LeadsPanel from "@/pages/admin/LeadsPanel";
import PricingPanel from "@/pages/admin/PricingPanel";
import UsersPanel from "@/pages/admin/UsersPanel";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Navigate to="features" replace />} />
                <Route path="features" element={<FeaturesPanel />} />
                <Route path="features/:id" element={<FeatureEditorPage />} />
                <Route path="categories" element={<CategoriesPanel />} />
                <Route path="industries" element={<IndustriesPanel />} />
                <Route path="tags" element={<TagsPanel />} />
                <Route path="settings" element={<SiteSettingsPanel />} />
                <Route path="leads" element={<LeadsPanel />} />
                <Route path="pricing" element={<PricingPanel />} />
                <Route path="users" element={<UsersPanel />} />
              </Route>
            </Routes>
            <Toaster position="bottom-right" richColors closeButton />
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
